<script>
  import { createEventDispatcher } from 'svelte';
  import request from 'superagent';
  import Select from 'svelte-select';
  import TreeSelection from './../../../../../components/menu/TreeSelection.svelte';
  import AutoComplete from "simple-svelte-autocomplete";
  
  const dispatch = createEventDispatcher();
  const defaultEvent = {
    id: null,   locale: "",  name: "", calendar_id: null, location_id: null,
    started_at: "",    ended_at: "",   flags: [],
    color: "#333333",  background: "#eeeeee",  uri: "",
    position: 0, image: ""
  };
  
  export let location_form_id = window.CALENDAR_LOCATION_FORM_ID
  export let form_id = window.CALENDAR_EVENT_FORM_ID;
  export let id = null;
  export let event = Object.assign({}, defaultEvent);
  export let calendars = [];
  export let regions = [];
  
  let municipalities = [];
  let locations = [];
  let selected_calendar = null;
  let selected_location = null;
  let selected_municipality_id = null;
  let selected_region_id = null;
  let selected_location_id = null;
  let location_name = "";
  let location_address = "";
  let success = false;
  
  $: event = Object.assign({}, defaultEvent, event);
  $: if (selected_location) location_address = selected_location['address']; // todo
  
  export function commit() {
    if (!selected_calendar || !selected_location_id) // TODO validation
      return;
  
    let call = event.id ? request.put : request.post;
    call(`/form/${form_id}`)
      .send(Object.assign({}, event, {
        calendar_id: selected_calendar.id,
        location_id: selected_location_id
      }))
      .then(resp => {
        event.id = resp.body.id;
        success = true;
        setTimeout(() => dispatch("event", event), 1345);
      })
      .catch(resp => {
        console.log("problem detected when commiting")
      });
  }
  
  function remove() {
    dispatch('remove');
  }
  
  function cancel() {
    dispatch("event", null)
  }
  const groupBy = (item) => item.parent_name;
  
  function regionSelected() {
    request.get('/p/c/municipalities.jsr?region_id='+window.atob(selected_region_id))
      .then(function(r) {
        if (r.ok) return r.body.count == 1 ? [r.body.data] : r.body.data || [];
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(data => {
        municipalities = data;
      })
      .catch(resp => {
        console.log(JSON.stringify(resp))
      })
  }
  
  function municipalitySelected(ev) {
    request.get('/p/c/locations.jsr?municipality='+window.atob(selected_municipality_id))
      .then(function(r) {
        if (r.ok) return r.body.count == 1 ? [r.body.data] : r.body.data || [];
        if (r.code != 401) throw Error(r.statusText);
      })
      .then(data => {
        locations = data;
      })
      .catch(resp => {
        console.log(JSON.stringify(resp))
      })
  }
  
  function locationSelected(ev) {
    console.log("locationSelected", ev.detail)
  }
  
  function submitLocation(name) {
    let call = selected_location_id ? request.put : request.post;
    let loc = {
      //id: selected_location_id,
      name: name,
      address: location_address,
      municipality_id: window.atob(selected_municipality_id),
      region_id: window.atob(selected_region_id)
    };
  
    call(`/form/${location_form_id}`)
      .send(loc)
      .then(function(r) {
        if (r.ok) return r.body.id;
        if (r.code != 401) throw Error(r.statusText);
      })
      .then((id) => {
        selected_location_id = window.btoa(""+id);
        loc.id = selected_location_id;
        locations = [loc, ...locations];
      })
      .catch(resp => {
        console.log("problem detected when commiting loc")
      });
    return loc;
  }
</script>
<div class='d-flex justify-content-start flex-column'>
<a class='btn btn-link text-secondary text-decoration-none pt-3 pt-3' on:click='{cancel}' on:keypress='{cancel}'>
<i class='fa fa-times'></i>
</a>
<a class='btn btn-link text-primary text-decoration-none pt-3 pt-3' on:click='{commit}' on:keypress='{commit}'>
<i class='fa fa-save'></i>
</a>
</div>
<div class='p-2 bg-white shadow-lg sidepanel w-75'>
<form action='/form/{form_id}' class='px-2'>
<div class='row bg-light py-1 my-1'>
<div class='col-12 col-md-12'>
<fieldset class='form-check form-check-inline'>
<input bind:group='{event.flags}' class='form-check-input' id='event-allday' type='checkbox' value='allDay'>
<label class='form-check-label text-muted' for='event-allday'>
<h6 class='m-0'>Celodenní</h6>
</label>
</fieldset>
</div>
</div>
<div class='row'>
<div class='col-6'>
<div class='row'>
<div class='col-12 col-md-12'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-name'>Pojmenování</label>
<input bind:value='{event.name}' class='form-control w-100 underline-input' id='event-title' placeholder='...' required>
</fieldset>
</div>
</div>
<div class='row'>
<div class='col-6 col-md-6'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-started_at'>Začátek</label>
<input bind:value='{event.started_at}' class='form-control w-100 underline-input' id='event-start' required type='datetime-local'>
</fieldset>
</div>
<div class='col-6 col-md-6'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-ended_at'>Konec</label>
<input bind:value='{event.ended_at}' class='form-control w-100 underline-input' id='event-end' required type='datetime-local'>
</fieldset>
</div>
</div>
<div class='row'>
<div class='col-6 col-md-6'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-background'>Barva pozadí</label>
<input bind:value='{event.background}' class='form-control w-100 underline-input' id='event-background' type='color'>
</fieldset>
</div>
<div class='col-6 col-md-6'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-color'>Barva textu</label>
<input bind:value='{event.color}' class='form-control w-100 underline-input' id='event-color' type='color'>
</fieldset>
</div>
<fieldset class='form-group col-12 col-md-12'>
<label class='form-text text-muted' for='event-body'>Popis</label>
<textarea bind:value='{event.about}' class='form-control w-100 underline-input' id='event-body' placeholder='...' rows='3'></textarea>
</fieldset>
<fieldset class='form-group col-12 col-md-12'>
<label class='form-text text-muted' for='event-image'>Obrázek/plakát</label>
<input bind:value='{event.image}' class='form-control w-100 underline-input' id='event-image' type='file'>
</fieldset>
</div>
</div>
<div class='col-6'>
<div class='row'>
<div class='col-12'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-calendar'>Zařazení</label>
<Select --width='100%' bind:value='{selected_calendar}' itemId='id' items='{calendars}' label='name' placeholder='' required='{true}'>
<div class='item' let:item slot='item'>
{item.name}
</div>
</Select>
</fieldset>
</div>
</div>
<div class='row'>
<div class='col-12'>
<fieldset class='form-group'>
<label class='form-text text-muted' for='region'>Region</label>
{#if regions.length}
<AutoComplete bind:value='{selected_region_id}' className='w-100' inputClassName='ui form-control' items='{regions}' labelFieldName='name' matchAllKeywords='{false}' onChange='{regionSelected}' placeholder='Zadejte okres ČR' sortByMatchedKeywords='{true}' valueFieldName='id'></AutoComplete>
{/if}
</fieldset>
<fieldset class='form-group'>
<label class='form-text text-muted' for='municipality'>Město</label>
<AutoComplete bind:value='{selected_municipality_id}' className='w-100' disabled='{!selected_region_id || !municipalities.length}' inputClassName='ui form-control' items='{municipalities}' labelFieldName='name' matchAllKeywords='{false}' onChange='{municipalitySelected}' placeholder='Zadejte obec' sortByMatchedKeywords='{true}' valueFieldName='id'></AutoComplete>
</fieldset>
<fieldset class='form-group'>
<label class='form-text text-muted' for='event-location'>Místo</label>
<input bind:value='{location_address}' class='form-control w-100 underline-input' disabled='{!selected_region_id || !selected_municipality_id}' id='location_address' placeholder='Adresa - ulice, číslo popisné aj.' type='text'>
<AutoComplete bind:selectedItem='{selected_location}' bind:value='{selected_location_id}' className='w-100' create='{true}' createText='Zkontroluje a potvrďte nové místo' disabled='{!selected_region_id || !selected_municipality_id}' inputClassName='ui form-control' items='{locations}' labelFieldName='name' matchAllKeywords='{true}' onCreate='{submitLocation}' placeholder='Název nebo popis místa' sortByMatchedKeywords='{true}' valueFieldName='id'></AutoComplete>
</fieldset>
</div>
</div>
<div class='row'>
<div class='col-12 p-3 text-center'>
<button class='btn btn-outline-primary' disabled='{!selected_location_id}' on:click|preventDefault='{commit}' on:keypress='{commit}'>
<i class='fa fa-save'></i>
Uložit
</button>
{#if success}
<span class='text-success'>
✓
</span>
{/if}
</div>
</div>
</div>
</div>
</form>
</div>
